export default __webpack_public_path__ + "static/media/graceIcon.78d87851.svg";